export default {"src":"/_next/static/media/gray-scale.f176c385.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};